package devxertech.com.pages.portfolio.auraNetwork


import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.pages.commons.CommonHeader
import devxertech.com.pages.commons.ZoneArrow
import devxertech.com.pages.dashboard.footerSection.HomepageFooter
import devxertech.com.pages.dashboard.ratingSection.RatingSection
import devxertech.com.pages.portfolio.zone.CommonAppView
import devxertech.com.pages.portfolio.zone.CommonWebView
import devxertech.com.pages.portfolio.zone.CommonZoneAbout
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Res

@Page("/auraNetwork")
@Composable
fun AuraNetwork() {
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()
    Column(
        modifier = Modifier.fillMaxSize().backgroundColor(sitePalette.bodyBackgroundSecondary.rgb)
    ) {
        CommonHeader(
            image = Res.Image.aura_header,
            breakpoint = breakpoint,
            headingText = "Aura Network",
            descriptionText = "The Aura is a conscious evolution of Auroville economics,away from an  " +
                    "individualistic life of survival, evolving  towards a life of creativity and communal harmony.",
            startProject = false, careerHeight = true, careerFontSize = true, heightModification = true, commonPortfolioChanges = true
        )
        ZoneArrow("Aura Network", largeTitle = true)
        CommonZoneAbout(image = Res.Image.aura_icon, title = "Aura Network",
            description = "The Aura is a conscious evolution of Auroville economics,away from an individualistic life of survival, evolving" +
                    " towards a life of creativity and communal harmony")
        CommonAppView(image = Res.Image.aura_png, breakpoint)
        CommonWebView(image = Res.Image.aura_webview, breakpoint)
        RatingSection(breakpoint)
        HomepageFooter(breakpoint)
    }
}